import { useMutation } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { PickingApiAdapter } from '../adapters/PickingApiAdapter';
import type { CancelResponse } from '../adapters/PickingApiAdapter';

export const useCancelPicking = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new PickingApiAdapter(httpClient);

  return useMutation<CancelResponse, Error, number>({
    mutationFn: (preparationId: number) => adapter.cancelPicking(preparationId),
  });
};
